<template>
  <div id="about_us_view">
    <div class="top_content" :style="{'flex-direction': shrink ? 'column-reverse' : 'row'}">
      <div class="headline">
        <div class="title">
          {{ $t("company.WIND_TO_LIQUID_COOLING_SOLUTION") }}
        </div>
        <div class="text">
          <div v-for="(item, index) in 3" :key="index" class="text_item">
            <div class="icon">
              <img src="@/assets/product/correct.svg" alt="" />
            </div>
            <span>{{ $t(`company.SOLUTION_SPAN_${index + 1}`) }}</span>
          </div>
        </div>
      </div>

      <div class="company_thumbnail">
        <img src="https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_home.jpg" alt="" />
      </div>
    </div>

    <div class="company_activity">
      <transition-group name="scaleUp">
        <div
          class="activity_item"
          v-for="(item, index) in activities"
          :key="index"
          :class="{ 'scale-up': currentIndex === index }"
        >
          <img :src="item" alt="" />
        </div>
      </transition-group>
    </div>

    <div class="asset">
      <div class="label">{{ $t("company.CONTACT_US") }}</div>
      <div
        class="introduce"
        :style="{ 'flex-direction': shrink ? 'column' : 'row' }"
      >
        <img src="@/assets/thumbtack.png" alt="" class="thumbtack" />
        <div class="introduce_left">
          <div class="options">
            <div class="option" v-for="(item, index) in 3" :key="index">
              <span>{{
                $t(`company.WHY_LIQUID_COOLING_DESCRIPTION_0${index + 1}`)
              }}</span>
            </div>
          </div>
        </div>
        <FormBar />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, reactive, ref } from "vue";
import provide_key from "@/constant/provide_key";
import FormBar from "./FormBar.vue";
const shrink: boolean | undefined = inject(provide_key.SHRINK);

const activities1 = [
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_1.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_2.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_3.jpg",
];

const activities2 = [
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_4.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_5.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_6.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_7.jpg",
];

const activities = ref(activities1);

const currentIndex = ref(0);

onMounted(() => {
  setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % activities1.length; // 更新当前索引
    if(currentIndex.value == 0) {
      if(activities.value[0] == activities1[0]) {
        activities.value = activities2;
      } else {
        activities.value = activities1;
      }}
  }, 2000); // 每隔两秒
});
</script>

<style lang="less" scoped>
#about_us_view {
  display: flex;
  align-items: center;
  gap: 6rem;
  width: 100%;
  max-width: var(--view-max-width);
  margin: 0 auto;
  background: var(--bg-color-white);
  padding: 4rem 2rem;
  flex-direction: column;
  margin-bottom: 4rem;
  margin-top: 1.5rem;
  position: relative;
  overflow-y: hidden;

  .top_content {
    display: flex;
    gap: 2rem;
    align-items: center;

    .company_thumbnail {
      width: 40%;
      height: 100%;
      overflow: hidden;
      border-radius: 2rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .headline {
      padding: 4rem 2rem;
      background: url("@/assets/logo_white.png") center center no-repeat;
      background-size: contain;
      flex: 1;

      .title {
        text-align: center;
        font-size: var(--label-title);
        margin-bottom: 2rem;
        font-weight: 700;
        overflow: hidden;
        font-family: "HarmonyOS_Bold";
        line-height: 3rem;
        color: var(--font-color-black-light);
      }

      .text {
        font-style: var(--label-description);
        font-weight: 400;
        color: var(--font-color-gray-light);

        &_item {
          display: flex;
          gap: 1rem;
          margin-top: 2rem;

          .icon {
            width: 1.5rem;
            height: 1.5rem;
            flex-shrink: 0;
            overflow: hidden;
            margin-top: 4px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .company_activity {
    display: flex;
    height: 20rem;
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow-y: hidden;
    padding: 0 4rem;
    gap: 4rem;

    .activity_item {
      height: 60%;
      width: 20%;
      border-radius: 1rem;
      overflow: hidden;
      transition: transform 1s ease;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .scale-up {
    transform: scale(1.5);
  }

  .asset {
    display: flex;
    justify-content: center;
    gap: 2rem;
    width: 100%;
    flex-direction: column;
    padding: 2rem 0;
    background: #f7f7f7;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;

    .thumbtack {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 2rem;
      right: 2rem;
    }

    .label {
      font-size: 2.5rem;
      font-weight: 700;
      overflow: hidden;
      line-height: 2.5rem;
      white-space: nowrap;
      text-align: center;
      color: var(--font-color-black-light);
    }

    .label_description {
      font-size: var(--label-description);
      font-weight: 400;
    }

    .thunbnail {
      height: 21rem;
      min-width: 30rem;
      overflow: hidden;
    }

    .introduce {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .introduce_left {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        margin-bottom: 2rem;
        width: 100%;
      }

      .options {
        display: flex;
        flex-direction: column;
        gap: 3rem;
        font-size: var(--label-description);
        width: 80%;

        .option {
          display: flex;
          gap: 12px;
          align-items: center;
          color: var(--font-color-black-light);
        }
      }
    }
  }
}

.activity_item {
  transition: transform 1s ease; // 动画过渡
}

.scale-up {
  transform: scale(1.5); // 放大效果
}

.scaleUp-enter-active,
.scaleUp-leave-active {
  transition: all 1s ease; // 过渡效果
}

.scaleUp-enter, .scaleUp-leave-to {
  opacity: 0; // 进入和离开时的透明度
  transform: scale(0.5); // 进入和离开时的缩放
}
</style>